import React from "react";
import { motion } from "framer-motion";
import { FaClipboardCheck, FaCodeBranch, FaUserShield, FaClock } from "react-icons/fa";

const items = [
  {
    icon: FaClipboardCheck,
    title: "Definicioni i “bërë”",
    text: "Çdo pikë kufitare vjen me shënime pranimi, prova testimi dhe changelog të përmbledhur.",
  },
  {
    icon: FaCodeBranch,
    title: "Kod bazë i dukshëm",
    text: "Historia Git, strategjia e degëve dhe shqyrtimet e strukturuara për mirëmbajtësit e ardhshëm — jo vetëm për ekipin e lançimit.",
  },
  {
    icon: FaUserShield,
    title: "Trajtimi i të dhënave",
    text: "Qasje me privilegje minimale, ndarje mjedisesh dhe NDA për angazhime të ndjeshme.",
  },
  {
    icon: FaClock,
    title: "Ritëm i parashikueshëm",
    text: "Demonstrime të rregullta, përditësime me shkrim dhe rrugë të qarta eskalimi për drejtorët e produktit dhe inxhinierisë.",
  },
];

function Stats() {
  return (
    <section
      className="commitments section-pad"
      id="commitments"
      aria-labelledby="commitments-heading"
    >
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Garanci</span>
          <h2 id="commitments-heading">Çfarë do të thotë këtu “dorëzim profesional”</h2>
          <p>
            Këto janë jo-negociueshme për mënyrën se si bashkëpunojmë — që prokurimi, IT-ja
            dhe drejtuesit e produktit të shohin të njëjtat fakte në të njëjtën kohë.
          </p>
        </div>

        <div className="commitments-grid">
          {items.map(({ icon: Icon, title, text }, i) => (
            <motion.article
              key={title}
              className="commitment-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              viewport={{ once: true, margin: "-40px" }}
            >
              <span className="commitment-icon" aria-hidden="true">
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
